import React, { useContext } from 'react'
import { FilterPills } from '@sainsburys-tech/bolt'
import { ThemeContext } from 'styled-components'
import { C002FiltersProps, FilterType } from './types'
import { StyledTagsContainer } from './C002.styles'
import { renderFilters, persistTagsInUrl } from '../../functional/UGC/ugc.helpers.js'

const C002Filters = ({
  filters,
  selectedFilters,
  setSelectedFilters,
  setLoadMore,
  sainsPage,
  totalPages,
  limit,
  fetchUGCdata
}: C002FiltersProps): React.ReactElement => {
  const theme = useContext(ThemeContext)
  const { channel } = theme
  const isSainsburys = channel === 'sainsburys'

  const updateSelectedTags = (tag) => {
    const lowerCaseFilter = tag.toLowerCase().trim()
    const filtersArray = [...selectedFilters]
    if (filtersArray.includes(lowerCaseFilter)) {
      filtersArray.splice(filtersArray.indexOf(lowerCaseFilter), 1)
    } else {
      filtersArray.push(lowerCaseFilter)
    }
    setSelectedFilters(filtersArray)
    persistTagsInUrl(filtersArray)

    if (isSainsburys) {
      setLoadMore(sainsPage < totalPages)
    }

    fetchUGCdata(false, isSainsburys ? sainsPage : limit, filtersArray)
  }

  return (
    <StyledTagsContainer data-test='c002-filters-container'>
      <FilterPills
        pills={renderFilters(filters, selectedFilters)}
        onActivate={(filter: FilterType) => updateSelectedTags(filter.reference)}
        onDeactivate={(filter: FilterType) => updateSelectedTags(filter.reference)}
        data-test='social-content-filters'
      />
    </StyledTagsContainer>
  )
}

export default C002Filters
